import {useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { isValidE164 } from "./EditPhoneNumberDialog.helper";
import { editPhoneDialogSx } from "./EditPhoneNumberDialog.styles";


const EditPhoneNumberDialog = ({ open, onClose, onSave, loading = false }) => {
  const [phone, setPhone] = useState("");


  const handleClose = () => {
    if (!loading) onClose();
  };

  const handleSave = () => {
    const trimmed = phone.trim();
    if (!isValidE164(trimmed)) return;
    onSave(trimmed);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      disableAutoFocus
      disableEnforceFocus
    >
      <DialogTitle>Editar número de teléfono</DialogTitle>
      <DialogContent sx={editPhoneDialogSx.content}>
        
        <Typography variant="body2" color="text.secondary" sx={editPhoneDialogSx.intro}>
          Elegí país con la bandera, escribí el número y guardá. Reemplaza el actual y queda{" "}
          <strong>sin verificar</strong>.
        </Typography>

        <Box sx={editPhoneDialogSx.phoneField}>
          <PhoneInput defaultCountry="ar" value={phone} onChange={setPhone} disabled={loading} />
        </Box>

      </DialogContent>

      <DialogActions sx={editPhoneDialogSx.actions}>

        <Button onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>

        <Button
          variant="contained"
          onClick={handleSave}
          disabled={loading || !isValidE164(phone)}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          Guardar
        </Button>

      </DialogActions>
    </Dialog>
  );
};

export default EditPhoneNumberDialog;
